export default __webpack_public_path__ + "static/media/shlomo-karaai.fbb52a77.png";